import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.44 7.379c-.377-.377-.92-.445-1.213-.152-.293.293-.225.836.152 1.212L10.939 12l-3.56 3.56c-.377.377-.445.92-.152 1.213.293.293.836.225 1.212-.152L12 13.061l3.56 3.56c.377.377.92.445 1.213.152.293-.293.225-.836-.151-1.212L13.06 12l3.56-3.56c.377-.377.445-.92.152-1.213-.293-.293-.836-.225-1.212.152L12 10.939 8.44 7.38Z\" fill=\"#3B3F3D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol